import { IProjectPropertyRentalContracts } from '~/@api/generated-api-types-project/Api'

function getProjectPropertyRentalContracts(
  rentalContracts: IProjectPropertyRentalContracts
) {
  return rentalContracts === IProjectPropertyRentalContracts.WithRentalContracts
    ? 'S nájomnými zmluvami'
    : 'Bez nájomných zmlúv'
}

export { getProjectPropertyRentalContracts }
